import type { RouteObject } from 'react-router-dom';
import { AppShell } from './AppShell';
import { HomePage } from '@/pages/HomePage';
import { CurriculumIndexPage } from '@/pages/CurriculumIndexPage';
import { ChapterPage } from '@/pages/ChapterPage';
import { CareersPage } from '@/pages/CareersPage';
import { AiFuturePage } from '@/pages/AiFuturePage';
import { BlogIndexPage } from '@/pages/BlogIndexPage';
import { BlogPostPage } from '@/pages/BlogPostPage';
import { CoursesHubPage } from '@/pages/CoursesHubPage';
import { CourseDetailPage } from '@/pages/CourseDetailPage';
import { ExamCornerPage } from '@/pages/ExamCornerPage';
import { ExcelCoursePage } from '@/pages/ExcelCoursePage';
import { ExcelClassPage } from '@/pages/ExcelClassPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { AboutPage } from '@/pages/legal/AboutPage';
import { PrivacyPage } from '@/pages/legal/PrivacyPage';
import { TermsPage } from '@/pages/legal/TermsPage';
import { ContactPage } from '@/pages/legal/ContactPage';
import { SourcesPage } from '@/pages/legal/SourcesPage';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'exam-corner', element: <ExamCornerPage /> },
      { path: 'excel-course',            element: <ExcelCoursePage /> },
      { path: 'excel-course/:classSlug', element: <ExcelClassPage /> },
      { path: 'careers',   element: <CareersPage /> },
      { path: 'careers/courses',       element: <CoursesHubPage /> },
      { path: 'careers/courses/:slug', element: <CourseDetailPage /> },
      { path: 'ai-and-you', element: <AiFuturePage /> },
      { path: 'blog',         element: <BlogIndexPage /> },
      { path: 'blog/:slug',   element: <BlogPostPage /> },
      { path: 'about',   element: <AboutPage /> },
      { path: 'privacy', element: <PrivacyPage /> },
      { path: 'terms',   element: <TermsPage /> },
      { path: 'contact', element: <ContactPage /> },
      { path: 'sources', element: <SourcesPage /> },
      { path: ':board/:grade/:subject', element: <CurriculumIndexPage /> },
      { path: ':board/:grade/:subject/:chapterSlug', element: <ChapterPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];
